var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquareClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 34,
    height: 34,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_35",
    "data-name": "Mask Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_window-close_",
    "data-name": "FontAwsome (window-close)",
    d: "M17.116,31H1.771A1.771,1.771,0,0,0,0,32.771V47.755a1.771,1.771,0,0,0,1.771,1.771H17.116a1.771,1.771,0,0,0,1.771-1.771V32.771A1.771,1.771,0,0,0,17.116,31Zm0,16.534a.222.222,0,0,1-.221.221H1.992a.222.222,0,0,1-.221-.221V32.992a.222.222,0,0,1,.221-.221h14.9a.222.222,0,0,1,.221.221Zm-3.784-9.793-2.265,2.265,2.265,2.265a.441.441,0,0,1,0,.62l-.823.823a.441.441,0,0,1-.62,0L9.625,41.448,7.36,43.713a.441.441,0,0,1-.62,0l-.823-.823a.441.441,0,0,1,0-.62l2.265-2.265L5.917,37.741a.441.441,0,0,1,0-.62L6.74,36.3a.441.441,0,0,1,.62,0l2.265,2.265L11.89,36.3a.441.441,0,0,1,.62,0l.823.823a.434.434,0,0,1,0,.62Z",
    transform: "translate(7.557 -23)",
    fill: "#85af26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareClose);
export default __webpack_public_path__ + "static/media/icon_square_close.486aff9e00ec7159a40f0808a06d07e6.svg";
export { ForwardRef as ReactComponent };